import * as React from 'react';

import CourseraPlusUpsellCard from 'bundles/unified-description-page-common/components/modules/upsell/CourseraPlusUpsellCard';
import DegreeUpsellCard from 'bundles/unified-description-page-common/components/modules/upsell/DegreeUpsellCard';
import EnterpriseUpsellCard from 'bundles/unified-description-page-common/components/modules/upsell/EnterpriseUpsellCard';
import UpsellModule from 'bundles/unified-description-page-common/components/modules/upsell/UpsellModule';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { useIsEnterpriseLearner } from 'bundles/unified-description-page-common/contexts/UserContext';
import { useCourseraPlusOwnership } from 'bundles/unified-description-page-common/contexts/consumer/CourseraPlusOwnershipContext';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';
import { UpsellCardNames } from 'bundles/unified-description-page-common/types/moduleConfig';

type Props = {
  config: { upsellCards: Array<(typeof UpsellCardNames)[keyof typeof UpsellCardNames]> };
};

const UpsellModuleRenderer = ({ config }: Props) => {
  const courseraPlusOwnership = useCourseraPlusOwnership();
  const { isEnterpriseLearner, loadingIsEnterpriseLearner } = useIsEnterpriseLearner();
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  if (!(config?.upsellCards?.length > 0)) {
    return null;
  }

  const cardsToRender = config.upsellCards.map((cardName) => {
    switch (cardName) {
      case UpsellCardNames.CourseraPlusUpsellCard:
        if (!courseraPlusOwnership?.isSubscribedToCPlusOrLite) {
          return <CourseraPlusUpsellCard />;
        }
        return null;
      case UpsellCardNames.DegreeUpsellCard:
        return <DegreeUpsellCard />;
      case UpsellCardNames.EnterpriseUpsellCard:
        if (!loadingIsEnterpriseLearner && !isEnterpriseLearner) {
          return <EnterpriseUpsellCard />;
        }
        return null;
      default:
        return null;
    }
  });

  const upsellModule = <UpsellModule cards={cardsToRender.filter((card) => card !== null)} />;

  if (enableXDPRedesign) {
    return <Section anchorId="upsell">{upsellModule}</Section>;
  }

  return upsellModule;
};

export default UpsellModuleRenderer;
